/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import Veiculo from 'Models/cadastros/Veiculo'
import IVeiculoTransportadora from 'Models/docas/IVeiculoTransportadora'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'
import IFormVeiculosFilter from 'Views/Cadastros/Veiculos/IFormVeiculosFilter'

const veiculos = {
  getList: async (
    idComponente: number,
    filter?: IFormVeiculosFilter,
    params?: ParamsRequest,
  ) => {
    let localFilters: IFormVeiculosFilter | undefined

    if (filter) {
      localFilters = filter

      if (filter?.situacao === 'ambos') {
        delete localFilters.ativo
      } else {
        localFilters.ativo = filter?.situacao === 'ativo'
      }
    }

    const result: AxiosResponse<ServiceListResponse<Veiculo>> =
      await ApiService({ idComponente }).get<ServiceListResponse<Veiculo>>(
        QueryStringFilter(`${hosts.WS_CADASTRO}/Veiculo`, localFilters, params),
      )

    if (result.data.items && result.data.items.length > 0) {
      result.data.items.sort((veiculo1, veiculo2) =>
        veiculo1.placa > veiculo2.placa ? 1 : -1,
      )
    }

    return result
  },
}

export default veiculos
